import {
  ButtonDesigns,
  ButtonTypes,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import Button from 'src/components/Button/Button'
import Trns from 'src/localization/Trns'
import { changePasswordUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

const ChangePasswordBox: React.FC = (): React.ReactElement => {
  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
        padding: 40px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            20,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Password'} />
      </div>
      <div
        css={css`
          ${getFontCss(
            12,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
          margin-top: 16px;
          margin-bottom: 40px;
        `}
      >
        <Trns
          source={
            'You will need to enter your current password as well as your desired new password.'
          }
        />
      </div>
      {/* will update button to shared component after component is updated */}
      <Button
        css={css`
          width: 179px;
          height: 50px;
        `}
        type={ButtonTypes.submit}
        design={ButtonDesigns.designCta}
        text={<Trns source={'Change Password'} />}
        linkProps={{
          to: changePasswordUrl(),
          ariaLabelSource: 'Change Password',
        }}
      />
    </Box>
  )
}

export default ChangePasswordBox
